import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
// 1. Sửa lại Import Firebase đúng chuẩn Realtime Database
import { ref, get, onValue, query, orderByChild, equalTo } from "firebase/database";
import { db } from "../../../assets/firebase/firebaseconfig";
import "react-quill-new/dist/quill.snow.css";
import "./styles.css";
import RatingSection from "../../ProductDetailPage/Components/RatingSection";
import { Helmet } from "react-helmet-async";
import Loading from "../../Loading";
import Info from "../../../assets/js/info";
import { createSlug } from "../../../assets/js/slug";

const ProjectDetail = () => {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [projectId, setProjectId] = useState(null); // Lưu ID thực tế để dùng cho RatingSection
  const [relatedProjects, setRelatedProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjectAndRelated = async () => {
      try {
        setLoading(true);
        const projectsRef = ref(db, "projects");

        // 2. Truy vấn: Tìm dự án có trường "slug" khớp với URL
        const projectQuery = query(projectsRef, orderByChild("slug"), equalTo(slug));
        const snapshot = await get(projectQuery);

        if (snapshot.exists()) {
          const data = snapshot.val();
          const key = Object.keys(data)[0]; // Lấy Key (ID) thực tế từ Firebase
          const projectData = { id: key, ...data[key] };
          
          setProjectId(key);
          setProject(projectData);

          // 3. Lấy dự án liên quan (Sắp xếp mới nhất và lọc bỏ bài hiện tại)
          const allSnapshot = await get(projectsRef);
          const allData = allSnapshot.val();
          if (allData) {
            const list = Object.keys(allData)
              .map((k) => ({ id: k, ...allData[k] }))
              .filter((item) => item.slug !== slug) // Lọc theo slug
              .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
              .slice(0, 5);
            setRelatedProjects(list);
          }
        } else {
          setProject(null);
        }
      } catch (error) {
        console.error("Lỗi lấy dữ liệu dự án:", error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchProjectAndRelated();
    }
    window.scrollTo(0, 0);
  }, [slug]);

  // 4. Hiệu ứng Scroll Reveal cho Sidebar
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".reveal-on-scroll");
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [relatedProjects]);

  if (loading) return <Loading />;
  if (!project) return <div className="error-state" style={{padding: "15rem", textAlign: "center"}}>Không tìm thấy dự án!</div>;

  return (
    <div className="news-page-bg">
      <Helmet>
        <title>{project.title} | Habako M&E</title>
        <meta name="description" content={project.title || project.title.substring(0, 150)} />
         <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "project", // Hoặc "Product" nếu là trang sản phẩm
      "headline": project.title,
      "description": project.description,
      "image": project.imageUrl,
      "author": {
        "@type": "Organization",
        "name": "Habako M&E"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Habako M&E",
        "logo": {
          "@type": "ImageObject",
          "url": "https://habakome-6d2ee.web.app/static/media/logo1.bded67026a0b99b52999.png"
        }
      },
      "datePublished": new Date(project.createdAt).toISOString()
    })}
  </script>
      </Helmet>
      
      <div className="container news-layout">
        <article className="news-main-content">
          <nav className="breadcrumb">
            <Link to="/">Trang chủ</Link> / <Link to="/du-an">Dự án</Link> /{" "}
            <span>{project.category}</span>
          </nav>

          <h1 className="news-title">{project.title}</h1>

          <div className="news-meta">
            <span className="news-date">
              <i className="far fa-calendar-alt"></i>{" "}
              {new Date(project.createdAt).toLocaleDateString("vi-VN")}
            </span>
            <span className="news-region">
              <i className="fas fa-map-marker-alt"></i>{" "}
              {project.region || "Toàn quốc"}
            </span>
            <span className={`status-tag ${project.status === "Đã hoàn thành" ? "done" : "doing"}`}>
              {project.status || "Đang triển khai"}
            </span>
          </div>

          <p className="news-sapo">
            {project.summary || `Dự án ${project.title} được HABAKO triển khai với tiêu chuẩn kỹ thuật khắt khe.`}
          </p>

          <div className="news-content">
            <img
              src={project.image || project.imageUrl}
              alt={project.title}
              className="content-image"
            />
            {/* Component Info xử lý dangerouslySetInnerHTML và clean HTML */}
            <Info product={project} typeName="Thông tin dự án" showFullDescription={true}/>
          </div>
        </article>

        {/* Truyền projectId thực tế để Rating hoạt động đúng */}
        <RatingSection productId={projectId} />

        <aside className="news-sidebar">
          <h2 className="sidebar-title">DỰ ÁN LIÊN QUAN</h2>
          <div className="related-list">
            {relatedProjects.map((item) => (
              <Link
                to={`/du-an/${item.slug || createSlug(item.title)}`}
                key={item.id}
                className="related-item reveal-on-scroll"
              >
                <img src={item.image || item.imageUrl} alt={item.title} />
                <div className="related-info">
                  <h4>{item.title}</h4>
                  <span>{item.region}</span>
                </div>
              </Link>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ProjectDetail;